import React, { useMemo } from 'react';
import { useFocusIdx, Stack } from '@bay-email/editor';
import { SelectField } from '../../../components/Form';

const options = [
  {
    value: 'top',
    get label() {
      return t('Top');
    },
  },
  {
    value: 'middle',
    get label() {
      return t('Middle');
    },
  },
  {
    value: 'bottom',
    get label() {
      return t('Bottom');
    },
  },
];

export function VerticalAlign({
  attributeName = 'vertical-align',
  // MJML renders columns/groups as inline-block boxes where CSS
  // `vertical-align: middle` doesn't geometrically center the box against its
  // taller sibling, so callers can hide values that don't work for their block.
  hiddenValues,
}: {
  attributeName?: string;
  hiddenValues?: string[];
}) {
  const { focusIdx } = useFocusIdx();

  return useMemo(() => {
    const filteredOptions = hiddenValues
      ? options.filter(option => !hiddenValues.includes(option.value))
      : options;

    return (
      <Stack>
        <SelectField
          style={{ width: 120 }}
          label={t('Vertical align')}
          name={`${focusIdx}.attributes.${attributeName}`}
          options={filteredOptions}
        />
      </Stack>
    );
  }, [attributeName, focusIdx, hiddenValues]);
}
